<script setup lang="ts">
import CreateButton from '@/components/Buttons/CreateButton.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import BaseDialog from '@/components/Modals/Dialog/BaseDialog.vue'
import store from '@/store'
import { EDetectionActions } from '@/store/detectionStore/DetectionStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { ESortBy, getSortByKey } from '@/types/enum/SortByEnum'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { CheckpointModel } from '../../../types/models/CheckpointModel'
import type { EventModel } from '../../../types/models/EventModel'
import FullScreenLoader from '../../LoadingSpinner/FullScreenLoader.vue'
import RadioButton from '../RadioButton.vue'

type Props = {
    sort?: ESortBy
    perPage?: number
    currentPage?: number
    event?: Partial<EventModel>
    poiId?: number
    checkpoint?: Partial<CheckpointModel>
    deviceId?: number
    hideEventSelector?: boolean

    disabled?: boolean

    filters?: Record<string, any>
    exportFilters?: Record<string, any>
    exportAction?: EDetectionActions
    exportFileNameData?: Record<string, any>
}
const props = defineProps<Props>()

const loading = ref(false)
const open = ref(false)
const { t } = useI18n()

const handleOpen = () => {
    open.value = true
}
const handleConfirm = () => {
    loading.value = true
    store
        .dispatch(`${EStoreModules.DETECTION}/${props.exportAction}`, {
            params: {
                filters: {
                    ...props.filters,
                    ...(props.exportFilters ?? {}),
                    device_id: props.deviceId
                },
                sort: props.sort ? getSortByKey(props.sort) : undefined,
                per_page: props.perPage,
                page: radioButtonValue.value
            },
            ...(props.exportFileNameData ?? {})
        })
        .finally(() => (loading.value = false))
}

const radioButtonValue = ref(props.currentPage)
const radioOptions = computed(() => [
    {
        label: t('detection.export.allDetections'),
        value: -1
    },
    {
        label: t('detection.export.currentPage', { page: props.currentPage }),
        value: props.currentPage
    }
])
</script>

<template>
    <FullScreenLoader :isLoading="loading" />
    <CreateButton :loading="loading" :label="$t('common.exportToCsv')" @click="handleOpen" />
    <BaseDialog
        :title="$t('common.exportToCsv')"
        :open="open"
        :loading="loading"
        @confirm="handleConfirm"
        @close="open = false"
        :disabled="$slots['exportFilters'] && disabled"
        class="event-checkpoint-component modal-selector-half-width">
        <template #content>
            <StackLayout direction="column" :gap="8" isResponsive>
                <StackLayout :gap="8" isResponsive>
                    <slot name="exportFilters" />
                </StackLayout>

                <StackLayout :gap="8" isResponsive>
                    <RadioButton
                        :modelValue="radioButtonValue"
                        :options="radioOptions"
                        @change="radioButtonValue = $event" />
                </StackLayout>
            </StackLayout>
        </template>
    </BaseDialog>
</template>
